const NewPlusIcon = props => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none'>
    <path fill='#696F88' d='M15 9H9v6H7V9H1V7h6V1h2v6h6v2Z' {...props} />
  </svg>
);

export default NewPlusIcon;
